module.exports = __webpack_public_path__ + "img/18.25f155a0.jpg";